import React from 'react';

import type { FC } from 'react';

export const Info: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M8.00065 1.33337C4.32065 1.33337 1.33398 4.32004 1.33398 8.00004C1.33398 11.68 4.32065 14.6667 8.00065 14.6667C11.6807 14.6667 14.6673 11.68 14.6673 8.00004C14.6673 4.32004 11.6807 1.33337 8.00065 1.33337ZM8.00065 11.3334C7.63398 11.3334 7.33398 11.0334 7.33398 10.6667V8.00004C7.33398 7.63337 7.63398 7.33337 8.00065 7.33337C8.36732 7.33337 8.66732 7.63337 8.66732 8.00004V10.6667C8.66732 11.0334 8.36732 11.3334 8.00065 11.3334ZM8.66732 6.00004H7.33398V4.66671H8.66732V6.00004Z" />
    </svg>
  );
};
